import React, { useEffect } from "react";

import { useCreateWebSettings } from "@/api/onboarding/create-web-settings";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import useUpdateQueryParams from "@/hooks/use-update-query-params";
import useGlobalLoading from "@/store/global-loading";
import useOnboardingData from "@/store/onboarding-data";

const Step1 = () => {
    const [platform, setPlatform] = React.useState("shopify");
    const handleChange = (value: string) => {
        setPlatform(value);
    };

    const updateSearchParams = useUpdateQueryParams();
    const { storeData } = useOnboardingData();
    const { setIsLoading } = useGlobalLoading();

    const { mutate: createWebSettings, isSuccess: createWebSettingsSuccess, isPending: createSettingsPending } = useCreateWebSettings();

    const handleSkip = () => {
        updateSearchParams({ step: "2" });
    };

    const handleSave = () => {
        createWebSettings({
            website_type: platform === "others" ? "custom" : platform,
            website_url: storeData?.name,
        });
    };

    useEffect(() => {
        if (createSettingsPending) {
            setIsLoading(true);
        }
        if (createWebSettingsSuccess && !createSettingsPending) {
            setIsLoading(false);
            updateSearchParams({ step: "2" });
        }
    }, [createWebSettingsSuccess, updateSearchParams, createSettingsPending, setIsLoading]);

    return (
        <div>
            <p className="my-4 text-base font-semibold">Select Your E-Commerce Platform</p>
            <RadioGroup defaultValue="comfortable" onValueChange={handleChange} value={platform} className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                    <RadioGroupItem value="shopify" id="shopify" />
                    <Label htmlFor="shopify" className="flex items-center gap-2">
                        <img src={"/assets/images/logo/shopify_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                        <p className="text-base font-semibold">Shopify</p>
                    </Label>
                </div>
                <div className="flex items-center space-x-2">
                    <RadioGroupItem value="wordpress" id="woocommerce" />
                    <Label htmlFor="woocommerce" className="flex items-center gap-2">
                        <img src={"/assets/images/logo/woocommerce_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                        <p className="text-base font-semibold">Woocommerce</p>
                    </Label>
                </div>
                {/* <div className="flex items-center space-x-2">
                    <RadioGroupItem value="magento" id="magento" />
                    <Label htmlFor="magento" className="flex items-center gap-2">
                        <img src={"/assets/images/logo/magento_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                        <p className="text-base font-semibold">Magento</p>
                    </Label>
                </div> */}
                <div className="flex items-center space-x-2">
                    <RadioGroupItem value="custom" id="custom" />
                    <Label htmlFor="custom" className="flex items-center gap-2">
                        <img src={"/assets/images/logo/custom_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                        <p className="text-base font-semibold">Custom CMS</p>
                    </Label>
                </div>
                <div className="flex items-center space-x-2">
                    <RadioGroupItem value="others" id="others" />
                    <Label htmlFor="others" className="flex items-center gap-2">
                        <img src={"/assets/images/logo/others_logo.png"} height={50} width={50} alt="Shopify Logo" className="size-7" />
                        <p className="text-base font-semibold">Others</p>
                    </Label>
                </div>
            </RadioGroup>
            <p className="mb-4 mt-6 text-base font-semibold">Enter E-Commerce URL</p>
            <Input placeholder="https://example.com" className="w-full py-6 text-gray-500" type="url" value={storeData?.name} readOnly />
            <div className="mt-6 flex justify-end gap-4">
                <Button variant={"secondary"} onClick={handleSkip}>
                    Skip For Now
                </Button>
                <Button onClick={handleSave}>Save & Proceed</Button>
            </div>
        </div>
    );
};

export default Step1;
